import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { SiteDto } from '../../api/ClientApi';
import { WarehouseClient } from '../../api/Extensions';
import { RootState } from '../reducers';
import { myAssert } from '../../common/console';
import { GraphClient } from '../../api/MSGraphExtensions';
import { KeyRolePair } from '../../api/RoleManagement';
import { GraphUserDto } from '../../api/msGraphApi';

export const addOrRemoveWarehouseOwner = createAction<string>('siteOwner/addOrRemoveWarehouseOwner');
export const clearSiteOwners = createAction('siteOwner/clearSiteOwners');

export const importAllSiteOwners = createAsyncThunk<string[], void>(
    'siteOwner/importAllSiteOwners',
    async (payload, thunkAPI) => {
        const WOsPromise = GraphClient.getAllUsers().then(async (res) => {
            let filteredWOs: GraphUserDto[] = [];
            const filteredWOsPromise: Promise<GraphUserDto | undefined>[] = [];

            res.map((u) => {
                const WOPromise = GraphClient.getUserAppRoles(u.id ?? '').then((roles) => {
                    if (!!roles.find((role) => role.appRoleId === KeyRolePair.WarehouseOwner)) {
                        return u;
                    }
                });

                filteredWOsPromise.push(WOPromise);
            });

            const savedItems = await Promise.all(filteredWOsPromise);

            filteredWOs = savedItems.map((item) => item ?? []).flat();

            return filteredWOs;
        });

        const allWOs = await WOsPromise;

        return allWOs.map((wo) => wo.id ?? []).flat();
    },
);

export const saveSiteOwners = createAsyncThunk<SiteDto, void>('siteOwner/saveSiteOwners', async (payload, thunkAPI) => {
    const rootState = thunkAPI.getState() as RootState;

    const site = rootState.siteOwners.site;
    const wos = rootState.siteOwners.currentWarehouseOwners;

    myAssert(() => site !== null);

    if (site === null) {
        throw new Error();
    }

    const tempSite = new SiteDto(site);
    tempSite.warehouseOwnersAzObjIds = wos ?? undefined;

    myAssert(() => tempSite.id !== undefined);

    if (tempSite.id === undefined) {
        throw new Error();
    }

    const sitePromise = WarehouseClient.updateSite(tempSite.id, tempSite as SiteDto);

    const allPromise = Promise.all([sitePromise]);

    await allPromise;

    const savedSite = await sitePromise;

    return savedSite;
});

export const importSiteForSiteOwnerForm = createAsyncThunk<SiteDto, number>(
    'siteOwner/importSiteForSiteOwnerForm',
    async (payload, thunkAPI) => {
        return WarehouseClient.getSiteById(payload, false, true);
    },
);
